import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 4062  -  显示动态图片2
 */
import EventFilter from './EventFilter'

export default class EventOaf extends EventBase {
  /**
   * 显示动态图片的构造函数
   */
  constructor() {
    super()
    this.Parameter = [
      '3',
      '',
      '0',
      '0',
      '0',
      '100',
      '100',
      '255',
      '0',
      '',
      '',
      '0',
      '',
      '',
      '',
      '',
      '0',
      '',
      '',
      '',
    ]
  }

  // #region 事件内关键属性参数
  /**
   * 图片ID
   */
  get PicId() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set PicId(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 图片相对路径
   */
  get PicPath() {
    return this.Parameter?.[1] || ''
  }
  set PicPath(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  /// <summary>n
  /// 图片坐标是否为橙光数值指定
  /// 0为非数值指定（常量），1为是橙光动态数值指定
  /// </summary>
  get IsAssigned() {
    return this.Parameter?.[2] == '1'
  }
  set IsAssigned(value) {
    this.Parameter && (this.Parameter[2] = value ? '1' : '0')
  }

  /**
   * X坐标
   */
  get X() {
    return parseInt(this.Parameter?.[3] ?? '')
  }
  set X(value) {
    this.Parameter && (this.Parameter[3] = value.toString())
  }

  /**
   * Y坐标
   */
  get Y() {
    return parseInt(this.Parameter?.[4] ?? '')
  }
  set Y(value) {
    this.Parameter && (this.Parameter[4] = value.toString())
  }
  /**
   * X轴缩放率
   */
  get ZoomX() {
    return parseInt(this.Parameter?.[5] ?? '')
  }
  set ZoomX(value) {
    this.Parameter && (this.Parameter[5] = value.toString())
  }
  /**
   * Y轴缩放率
   */
  get ZoomY() {
    return parseInt(this.Parameter?.[6] ?? '')
  }
  set ZoomY(value) {
    this.Parameter && (this.Parameter[6] = value.toString())
  }
  /**
   * 图片透明度，0~255
   */
  get Opacity() {
    return parseInt(this.Parameter?.[7] ?? '')
  }
  set Opacity(value) {
    this.Parameter && (this.Parameter[7] = value.toString())
  }
  /// <summary>
  /// 是否使用了镜像功能
  /// 0否1是
  /// </summary>
  get IsMirror() {
    return this.Parameter?.[8] == '1'
  }
  set IsMirror(value) {
    this.Parameter && (this.Parameter[8] = value ? '1' : '0')
  }
  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[9] || ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[9] = value.toString())
  }

  /// <summary>
  /// 是否素材来源自云网盘
  /// 2是（云网盘公有区资源）
  /// </summary>
  get IsPublicwebdisk() {
    return this.Parameter?.[10] == '2'
  }
  set IsPublicwebdisk(value) {
    this.Parameter && (this.Parameter[10] = value ? '1' : '2')
  }

  /// <summary>
  /// 图片名称是否为橙光字符串指定
  /// 0为是非字符串指定（固定图片），1为是橙光动态字符串指定
  /// </summary>
  get IsUserStrAssigned() {
    return this.Parameter?.[11] == '1'
  }
  set IsUserStrAssigned(value) {
    this.Parameter && (this.Parameter[11] = value ? '1' : '0')
  }
  /// <summary>
  /// 指定的为橙光字符串索引
  /// 如果不存在则返回-1
  /// </summary>
  get UserAssignedStrID() {
    return this.IsUserStrAssigned ? parseInt(this.Parameter?.[12] ?? '') : -1
  }
  set UserAssignedStrID(value) {
    this.Parameter &&
      (this.Parameter[12] = this.IsUserStrAssigned ? value.toString() : '-1')
  }

  /**
   * 低画质版相对路径（暂时没用）
   */
  get LowQualityPath() {
    return this.Parameter?.[13] || ''
  }
  set LowQualityPath(value) {
    this.Parameter && (this.Parameter[13] = value.toString())
  }

  /// <summary>
  /// 显示的动作编号，（英文逗号,分隔）类型（0播放一遍1循环2跟随说话）|若干组，用|分隔）
  ///	形如0,1|1,1|2,3
  /// </summary>
  get ShowActionNumber() {
    return this.Parameter?.[14] || ''
  }
  set ShowActionNumber(value) {
    this.Parameter && (this.Parameter[14] = value.toString())
  }

  /// <summary>
  /// 高级控制参数，也分若干组，分隔方式同上
  ///	目前第一组：string-跟随时的姓名
  /// </summary>
  get HighControlParameter() {
    return this.Parameter?.[15] || ''
  }
  set HighControlParameter(value) {
    this.Parameter && (this.Parameter[15] = value.toString())
  }
  
  //   // #endregion

  /**
   * 事件ID
   */
  Code = EventID.Oaf2

  get Filter() {
    return new EventFilter(this.Parameter ?? [], 16)
  }
  set Filter(value) {
    this.Parameter = value.ToParameter(this.Parameter ?? [], 16)
  }

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}


